import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {Router} from "@angular/router"
import {OwlCarousel} from 'ngx-owl-carousel';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { NgxSmartModalService } from 'ngx-smart-modal';
@Component({
  selector: 'app-call-to-action',
  templateUrl: './call-to-action.component.html',
  styleUrls: ['./call-to-action.component.scss']
})
export class CallToActionComponent implements OnInit {

  constructor(public ngxSmartModalService: NgxSmartModalService, private spinner: NgxSpinnerService, public http: HttpClient, private router: Router) {}
  allchannels: any = [];
  numbers: any = [];
  validateChan = false;
  isSubscriber:boolean = false;
  isWoohoo: boolean = environment['isWooHoo'];
  sliderOptions = { dots: false, navigation: true, nav: true, navText : ['<i class="fa fa-angle-left" aria-hidden="true"></i>','<i class="fa fa-angle-right" aria-hidden="true"></i>'], autoplay: false, loop: true, autoplayTimeout: 2000, autoplayHoverPause: true,  lazyLoad: true, responsive:{ 0:{ items: 3 }, 600:{ items: 5 }, 960:{ items: 5 }, 1200:{ items: 5 } } };
  config = {slidesPerView: 'auto',autoHeight: true, navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }, loop: false,
  breakpoints: {
    // when window width is <= 320px
    320: {
      slidesPerView: 'auto',
      spaceBetween: 0
    },
    // when window width is <= 480px
    480: {
      slidesPerView: 'auto',
      spaceBetween: 0
    },
    // when window width is <= 720px
    720: {
      slidesPerView: 'auto',
      spaceBetween: 0
    },
    // when window width is <= 720px
    1000: {
      slidesPerView: 'auto',
      spaceBetween: 0
    }
  }
};

  ngOnInit() {
    /** spinner starts on init */
    this.spinner.show();
 
    setTimeout(() => {
        /** spinner ends after 5 seconds */
        this.spinner.hide();
    }, 5000);
  }
  
}